import type { Meta, StoryObj } from '@storybook/web-components';

import { createDocumentation, createComponent } from '@/globals/documentation/story';
import docs from './pn-qr-code-generator-docs.json';

const { argTypes, textContent } = createDocumentation(docs);

const meta: Meta<HTMLPnQrCodeGeneratorElement> = {
  title: 'Components/Widgets/Qr code generator',
  parameters: {
    actions: {
    },
    docs: {
      description: {
        story: textContent
      }
    }
  },
  args: {
      url: 'https://se-integration.postnord.com',
      countdownSeconds: 30,
      outdatedMessage: 'The QR has expired',
      expiresInMessage: 'Expires in',
      updateCodeEverySecond: true,
      ariaLabel: 'QR Code Generator'
  },
  argTypes,
};

type Story = StoryObj<HTMLPnQrCodeGeneratorElement>;

export default meta;

export const QrCodeGenerator: Story = {
  name: 'pn-qr-code-generator',
  render: (args) => createComponent('pn-qr-code-generator', args),
};
